import { useState } from "react";
import { toast } from "sonner";
import { BeatShell, NumberField } from "@/components/nutrition/NutritionParts";
import { gradeNumber, beatMax, tidy, ICON_BY_TYPE } from "../beatUtils";
import { Briefing } from "./Shared";

export function NumberBeat({ beat, eyebrow, showBriefing, c, accent, onDone }) {
  const [vals, setVals] = useState(beat.fields.map(() => ""));
  const [res, setRes] = useState(null);
  const checked = !!res;
  const Icon = beat.icon || ICON_BY_TYPE.number;
  const setVal = (i, v) => setVals((p) => p.map((x, idx) => (idx === i ? v : x)));
  const onPrimary = () => {
    if (!checked) {
      if (vals.some((v) => v === "")) return toast.error("Enter all the values.");
      const fieldRes = beat.fields.map((f, i) => gradeNumber(vals[i], f.correct, f.full ?? 10));
      const earned = fieldRes.reduce((a, r) => a + r.pts, 0);
      setRes({ fieldRes, scoreObj: { earned, max: beatMax(beat), detail: beat.detail || "", key: beat.key, label: beat.label } });
    } else onDone(res.scoreObj);
  };
  return (
    <BeatShell Icon={Icon} eyebrow={eyebrow} title={beat.title} subtitle={beat.prompt}
      primaryLabel={checked ? beat.last ? "See debrief →" : "Continue →" : "Check answers"} onPrimary={onPrimary} primaryTestId={`${beat.key}-primary-btn`} accent={accent}>
      {showBriefing && <Briefing c={c} />}
      {beat.given && (
        <div className="rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700 font-mono-clinical" data-testid={`${beat.key}-given`}>{beat.given}</div>
      )}
      {beat.fields.map((f, i) => (
        <NumberField key={i} testid={`${beat.key}-field-${i}`} label={f.label} unit={f.unit} hint={f.hint}
          value={vals[i]} onChange={(v) => setVal(i, v)} disabled={checked}
          result={res?.fieldRes?.[i]} correctText={`${tidy(f.correct)} ${f.unit}`} />
      ))}
    </BeatShell>
  );
}
